.trigger {
    width: 24px;
    height: 24px;
    color: var(--color-contrast);
}

.svg {
    margin-top: 3px;
    width: 16px;
    height: 16px;
    fill: currentColor;
}

.socialButtonSuccess svg {
    fill: green;
}

.socialButtonFailure svg {
    fill: purple;
}

.dialog {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
    min-width: 125px;
    background-color: var(--background-color);
    padding: var(--spacer-24);
    border: 1px solid var(--border-color);
    font: var(--font-p-16);
}

.clickable {
    color: var(--brown);
}

.clickableSvg {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: var(--spacer-8);
    fill: currentColor;
    translate: 0 3px;
}
